export var Records;
(function (Records) {
    function bindScope(client) {
        return {
            DownloadRecord: client.bindCallable({
                name: 'DownloadRecord',
                scope: 'records',
                path: '/api/records/download-record',
                method: 'post',
                kind: 'api',
            }),
        };
    }
    Records.bindScope = bindScope;
})(Records || (Records = {}));
//# sourceMappingURL=records.js.map